import { publicAPI } from '../public_api/publicAPI'
import useSWR from 'swr'



export const useProductsStock = (articlesArr = []) => {
  const query = articlesArr.join(';')
  const shouldFetch = articlesArr.length > 0
  const articlesKey = JSON.stringify(articlesArr.sort())
  const fetcher = async () => {
    const res = await publicAPI.getPositionsStock(query)
    const { status, data } = res.data.result
    if (status === 'success') {
      return data
    }
    throw new Error('Fetch failed')
  }

  const { data, error, isLoading } = useSWR(
    shouldFetch ? `stock-${articlesKey}` : null,
    fetcher,
    {
      dedupingInterval: 1000 * 60 * 5 // 5 минут
    }
  )

  return {
    positionsStock: data ?? {},
    isLoading,
    isError: !!error
  }
}